import { alkymetricsClient } from './alkymetricsClient';

export async function getCountries() {
  return alkymetricsClient.get('/country').then(response => {
    return response.data;
  });
}
